import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Editor from 'components/Common/TextEditor';
import parse from 'html-react-parser';

interface ManualInputProps {
    value: string;
    onChange: (value: string) => void;
    readOnly?: boolean;
    showToolbar: boolean;
    isGenerating: boolean;
    isLoading: boolean;
    isGeneratingOrder: boolean;
    notValue: boolean;
}

const ManualInput: React.FC<ManualInputProps> = ({
    value,
    onChange,
    readOnly = false,
    showToolbar,
    isGenerating,
    isLoading,
    isGeneratingOrder,
    notValue,
}) => {
    const { t } = useTranslation();
    const [offset, setOffset] = useState(32);
    const [isSettled, setIsSettled] = useState(false);
    const showLoading = (isGeneratingOrder || isGenerating || isLoading) && notValue && isSettled;
    const showPlaceholder =
        !isGenerating && !isGeneratingOrder && !isLoading && notValue && isSettled;

    useEffect(() => {
        const updateOffset = () => {
            const element = document.querySelector(
                '.intake-notes-editor-content .ql-toolbar.ql-snow',
            );
            if (element && showToolbar) {
                setOffset(element.clientHeight + 32);
            } else {
                setOffset(32);
            }
            setIsSettled(true);
        };

        // Initial measurement
        updateOffset();

        // Update on window resize
        window.addEventListener('resize', updateOffset);

        return () => window.removeEventListener('resize', updateOffset);
    }, [showToolbar, isLoading, notValue]);

    return (
        <Box
            className="intake-notes-editor-content"
            sx={{ display: 'flex', flexDirection: 'column' }}
        >
            <Editor
                value={value}
                onChange={onChange}
                readOnly={readOnly}
                showToolbar={showToolbar}
            />
            {showLoading && (
                <Box sx={{ top: offset }} className="intake-notes-placeholder">
                    <Typography variant="body1" className="animated-placeholder">
                        {t('web_app.home.loading')}...
                    </Typography>
                </Box>
            )}

            {showPlaceholder && (
                <Box sx={{ top: offset }} className="intake-notes-placeholder">
                    <Typography variant="body1" className="animated-placeholder">
                        {t('web_app.tooltips.intake_notes')}
                    </Typography>
                    {parse(t('web_app.home.intake_notes.placeholder'))}
                </Box>
            )}
        </Box>
    );
};

export default ManualInput;
